import { call, put, select, takeEvery, takeLatest } from "redux-saga/effects";
import { addMinutes } from "date-fns";

import {
  FetchSubscriptionsAction,
  FetchDocumentsAction,
  setSubscriptions,
  setSubscriptionsLoading,
  setSubscriptionsError,
  setDocuments,
  setDocumentsLoading,
  setDocumentsError,
  FETCH_SUBSCRIPTIONS,
  FETCH_DOCUMENTS,
} from "../actions/subscriptions.actions";
import { dataPacksApi, Subscription } from "../../api";
import { IStateType } from "../models/root.interface";
import { DocumentList, ISubscriptionsState } from "../models/subscriptions.interface";

const api = {
  getSubscriptions: (...args: Parameters<typeof dataPacksApi.getSubscriptions>) =>
    dataPacksApi.getSubscriptions(...args),
  getDocuments: (...args: Parameters<typeof dataPacksApi.getDocuments>) =>
    dataPacksApi.getDocuments(...args),
}

function* fetchSubscriptions(action: FetchSubscriptionsAction) {
  const state: ISubscriptionsState = yield select((state: IStateType) => state.subscriptions);
  if (!state.items || state.items === "error") {
    // Denote loading
    yield put(setSubscriptionsLoading());
    try {
      // Request
      const { data } = yield call(api.getSubscriptions);
      // Store data
      yield put(setSubscriptions((data as Subscription[]).map(item => ({
        ...item,
        id: (item.name ?? "").replace(/\W+/g, "-").toLowerCase(),
      }))));
    } catch (e) {
      // Denote error
      yield put(setSubscriptionsError());
    }
  }
}

function* fetchDocuments(action: FetchDocumentsAction) {
  const { subscription } = action;
  const state: DocumentList | "loading" | "error" | undefined = yield select((state: IStateType) => state.subscriptions.documents[subscription]);
  if (!state || state === "error" || (state !== "loading" && state.expires <= new Date().valueOf())) {
    // Denote loading
    yield put(setDocumentsLoading(subscription));
    try {
      // Request
      const { data } = yield call(api.getDocuments, { subscription });
      // Set an expiry time
      const expires = addMinutes(new Date(), 10).valueOf();
      // Store data
      yield put(setDocuments(subscription, data, expires));
    } catch (e) {
      // Denote error
      yield put(setDocumentsError(subscription));
    }
  }
}

function* subscriptionsSaga() {
  yield takeLatest(FETCH_SUBSCRIPTIONS, fetchSubscriptions);
  yield takeEvery(FETCH_DOCUMENTS, fetchDocuments);
}

export default subscriptionsSaga;
